import { Config as ConfigType } from './types';
import { user } from './swim/user';
import { expert } from './swim/expert';
import { client } from './swim/client';
import { company } from './swim/company';
import { mission } from './swim/mission';
import { invitation } from './swim/invitation';
import { candidate } from './swim/candidate';
import { candidacy } from './swim/candidacy';
import { proposal } from './swim/proposal';
import { quotation } from './swim/quotation';
import { charge } from './swim/charge';
import { milestone } from './swim/milestone';
import { contract } from './swim/contract';
import { contractMilestone } from './swim/contractMilestone';
import { invoice } from './swim/invoice';
import { recommendation } from './swim/recommendation';
import { legalInformation } from './swim/legalInformation';
import { cgu } from './swim/cgu';
import { match } from './swim/match';
import { document } from './swim/document';
import { subCategory } from './swim/subCategory';
import { documentFile } from './swim/documentFile';
import { documentsCompanies } from './swim/documentsCompanies';
import { tag } from './swim/tag';
import { clientInvoice } from './swim/clientInvoice';
import { expertInvoice } from './swim/expertInvoice';

export const config: ConfigType = {
  login: 'password',
  hash: '4rr0tdosatvzb70almrhxtkbk',
  locale: 'fr',
  name: 'swim',
  dashboard: true,
  theme: {
    primary: '#FF8B43',
    secondary: '#0b95a2',
    info: '#086972',
  },
  defaultCountry: 'fr',
  preferredCountries: ['fr', 'be', 'ch'],
  invoiceUploadedByUser: false,
  resources: [
    expert,
    client,
    user,
    subCategory,
    company,
    mission,
    invitation,
    candidate,
    candidacy,
    proposal,
    quotation,
    charge,
    milestone,
    contract,
    contractMilestone,
    invoice,
    recommendation,
    legalInformation,
    document,
    documentFile,
    documentsCompanies,
    cgu,
    match,
    tag,
    clientInvoice,
    expertInvoice,
  ],
};

export default config;
